import React from "react";
import { services, spillTest } from "../mock";

const Services = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="services" data-testid="services-section">
      {/* Services intro + cards on light grey */}
      <div className="bg-grey px-4 md:px-[30px] pt-10 pb-8">
        <div className="max-w-[1140px] mx-auto text-center fade-up">
          <h2 className="text-charcoal font-medium text-[25px] md:text-[28px]">
            Multi Fuel and Wood Burning Stove Services
          </h2>
          <div className="py-1">
            <span className="block mx-auto w-[30%] h-[1.1px] bg-fire" />
          </div>
          <p className="text-charcoal text-[16px] mt-2">
            Stove Scotland is a family business that is committed to providing you high quality service and excellent
            customer satisfaction
          </p>
        </div>

        <div className="max-w-[1140px] mx-auto grid md:grid-cols-3 gap-[10px] mt-6">
          {services.map((s) => (
            <div key={s.title} className="service-card bg-white p-[15px] fade-up" data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <div className="overflow-hidden mb-[15px]">
                <img src={s.img} alt={s.title} loading="lazy" className="w-full aspect-[4/3] object-cover" />
              </div>
              <h3 className="text-fire font-semibold text-[22px]">{s.title}</h3>
              <p className="text-charcoal text-[15px] leading-relaxed mt-2">{s.body}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Spill test on white */}
      <div className="bg-white px-4 md:px-10 py-10" data-testid="spill-test-section">
        <div className="max-w-[1140px] mx-auto grid md:grid-cols-4 gap-6 items-center">
          <div className="md:col-span-3 fade-up md:pr-5">
            <h3 className="text-charcoal font-medium text-[21px] md:text-[28px]">{spillTest.heading}</h3>
            <div className="py-1">
              <span className="block w-[30%] h-[1.1px] bg-fire" />
            </div>
            <p className="text-charcoal text-[16px] mt-2">{spillTest.body1}</p>
            <p className="text-charcoal text-[16px] mt-3">{spillTest.body2}</p>
            <p className="text-charcoal text-[16px] mt-3">{spillTest.body3}</p>
            <button onClick={() => go("#quote")} className="btn-fire mt-6 px-6 py-3 text-[15px] md:text-[17px]" data-testid="spill-test-button">
              Book My Spill Test
            </button>
          </div>
          <div className="fade-up">
            <img src={services[1].img} alt="stove scotland wood burning stove" loading="lazy" className="w-full object-cover" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
